import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG } from "@/lib/images";
import { PROJECTS } from "@/lib/content";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";
import { pageSEO } from "@/lib/seo";
import { useLang } from "@/i18n/LanguageContext";

export default function Portfolio() {
  const { c, lang } = useLang();
  const p = c.pages.portfolio;
  return (
    <div data-testid="portfolio-page">
      <SEO {...pageSEO("portfolio", lang)} path="/portfolio" lang={lang} image={IMG.weddingHero} />
      <PageHeader eyebrow={p.eyebrow} lines={p.hLines} title="Portfolio" subtitle={p.subtitle} image={IMG.weddingHero} />

      <section className="py-24 lg:py-32 bg-olime-bg">
        <div className="container-olime grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-16">
          {PROJECTS.map((proj, i) => (
            <Reveal key={proj.slug} delay={(i % 2) * 0.1} className={i % 2 === 1 ? "md:mt-20" : ""}>
              <Link to={`/portfolio/${proj.slug}`} data-testid={`portfolio-item-${proj.slug}`} className="group block">
                <div className="relative overflow-hidden">
                  <img src={proj.image} alt={proj.name} loading="lazy" className="w-full aspect-[16/11] object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105" />
                </div>
                <div className="flex justify-between items-start mt-5">
                  <div>
                    <h3 className="font-serif text-3xl">{proj.name}</h3>
                    <p className="text-sm text-olime-muted mt-1">{proj.location} — {c.projects[proj.slug].type}</p>
                  </div>
                  <span className="font-serif text-2xl text-olime-stone">{proj.year}</span>
                </div>
                <span className="inline-flex items-center gap-2 mt-4 text-xs uppercase tracking-[0.2em] link-underline">{c.cta.discoverProject} <ArrowRight size={13} /></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-20 lg:py-24 bg-olime-ink text-white" data-testid="portfolio-cta">
        <div className="container-olime flex flex-col items-center text-center gap-7">
          <Reveal><h2 className="font-serif text-3xl md:text-5xl tracking-tight !text-white max-w-2xl">{c.book.title}</h2></Reveal>
          <Reveal delay={0.1}><Link to="/contact#form" data-testid="portfolio-quote-cta" className="btn-light">{c.cta.quote} <ArrowRight size={14} /></Link></Reveal>
        </div>
      </section>
    </div>
  );
}
